/* eslint-disable no-unused-vars */
import styled from 'styled-components'
import PropTypes from 'prop-types'

const Wrapper = styled.div``
const RangePicker = ({
  minStartDate,
  maxEndDate,
  startDate = null,
  endDate = null,
  onStartDateChange = () => {},
  onEndDateChange = () => {},
  onClear = () => {}
}) => {
  return <Wrapper>TODO: date range picker</Wrapper>
}

RangePicker.propTypes = {
  minStartDate: PropTypes.instanceOf(Date),
  maxEndDate: PropTypes.instanceOf(Date),
  startDate: PropTypes.instanceOf(Date),
  endDate: PropTypes.instanceOf(Date),
  onStartDateChange: PropTypes.func,
  onEndDateChange: PropTypes.func,
  onClear: PropTypes.func
}

export { RangePicker }
